<template>
  <div class="producEdit">
    <Modal
      class="common-drawer newModal producEdit"
      v-model="value"
      title="配置点表"
      width="1400"
      :mask-closable="false"
      @on-cancel="closeDrawer"
      class-name="vertical-center-modal"
    >
      <div slot="header" class="u-flex u-row-between">
        <div class="product-title">配置点表</div>

        <div class="resetIcon pot" @click="redustRest">
          <Tooltip :transfer="true" content="显示默认配置" theme="light">
            <div class="resetIcon-border">
              <div class="resetIcon-img"></div>
            </div>
            <!-- <img src="@/assets/images/ckmrdb.svg" /> -->
          </Tooltip>
        </div>
      </div>
      <div class="common-list table-margin">
        <Table
          :loading="loading"
          class="equipmentTable"
          row-key="id"
          :columns="dataColumn"
          :data="dataLists"
        ></Table>
      </div>
      <div class="drawer-footer" slot="footer">
        <Button type="primary" @click="submitForm()">提交</Button>
        <Button style="margin-left: 8px" @click="closeDrawer">取消</Button>
      </div>
      <div class="rh-model" v-if="timbo" @click="modelmehods1"></div>
    </Modal>
    <producteditDrawer
      @change="promChangeMeods"
      :getLists="getLists"
      :form="form"
      v-model="productShow"
      :modelmehods="modelmehods1"
      :timbo="timbo"
    />
  </div>
</template>
<script>
import producteditDrawer from "./productedit-drawer.vue";
import { productList,productTemplate } from "@/api/knowledge/gateway";

const registerTypeList = [
  {
    label: 'Coils',
    value: '0'
  },
  {
    label: 'Input Discrete',
    value: '1'
  },
  {
    label: 'Input Registers',
    value: '3'
  },
  {
    label: 'Holding Registers',
    value: '4'
  },
];
const byteOrderList = [
  {
    label: 'ABCD',
    value: '1'
  },
  {
    label: 'BADC',
    value: '2'
  },
  {
    label: 'CDAB',
    value: '3'
  },
  {
    label: 'DCBA',
    value: '4'
  },
];

export default {
  props: ["value", "list", "id", "modelmehods", "timbo", "reductionList","zhuangzhiId"],
  components: { producteditDrawer },
  data() {
    return {
      dataColumn: [],
      form: {},
      productShow: false,
      dataLists: [],
      loading: false,
      dataTypes: [
        "",
        "BOOL",
        "INT8",
        "UINT8",
        "INT16",
        "UINT16",
        "INT32",
        "UINT32",
        "INT64",
        "UINT64",
        "FLOAT",
        "DOUBLE",
      ]
    };
  },
  watch: {
    value(newvalue) {
      if (newvalue) {
        this.loading = true;
        setTimeout(() => {
          this.dataLists = this.$c.deepClone(this.list);
          this.loading = false;
        }, 300);
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async redustRest() {
      let {data}=await productTemplate({
        gatewayId:this.id,
        zhuangzhiId:this.zhuangzhiId
      })
     this.dataLists=data
      // this.dataLists = this.$c.deepClone(this.reductionList);
    },
    modelmehods1() {
      this.modelmehods();
      this.productShow = false;
      this.closeDrawer();
    },
    submitForm() {
      this.$emit("change", { list: this.$c.deepClone(this.dataLists) });
      this.closeDrawer();
    },
    promChangeMeods({ form }) {
      let findIndex = this.dataLists.findIndex((e) => e.iconId == form.iconId);

      this.$set(this.dataLists, findIndex, form);
    },
    editDetailType(item) {
      let form = this.$c.deepClone(item);
      // form.valueFrom = Number(form.valueFrom);
      // form.valueTo = Number(form.valueTo);
      this.form = form;
      this.productShow = true;
    },
    async getLists() {
      let res = await productList(this.id.toString());

      if (res.code === "00000") {
        this.dataLists = res.data;
      }
      this.$store.state.spinShow = false;
    },
    init() {
      this.dataColumn = [
        {
          title: "属性编码",
          key: "name",

          tree: true,
          render: (h, params) => {
            const item = params.row;
            let identifier = item.identifier;
            return h("span", identifier);
          },
        },
        {
          title: "属性名称",
          key: "propertyName",

          tree: true,
          render: (h, params) => {
            const item = params.row;
            let propertyName = item.propertyName;
            return h("span", propertyName);
          },
        },

        {
          title: "单位",
          key: "uom",

          tree: true,
          render: (h, params) => {
            const item = params.row;
            let uom = item.uom;
            return h("span", uom);
          },
        },
        {
          title: "数据范围",
          key: "value",

          tree: true,
          render: (h, params) => {
            const item = params.row;
            const { valueFrom, valueTo } = item;

            let text = "-";

            if ((valueFrom || valueFrom == 0) && valueTo) {
              text = `${valueFrom}-${valueTo}`;
            } else if (valueFrom || valueFrom == 0) {
              text = `${valueFrom}`;
            } else if (valueTo) {
              text = `${valueTo}`;
            }
            return h("span", text);
          },
        },
        {
          title: "寄存器类型",
          key: "registerType",
          tree: true,
          render: (h, params) => {
            const registerType = params.row.registerType;
            return h("span", registerType ? registerTypeList.find((item) => item.value === registerType).label : '-');
          },
        },
        {
          title: "偏移量",
          key: "offset",
          tree: true,
          render: (h, params) => {
            const offset = params.row.offset;
            return h("span", offset || '-');
          },
        },
        {
          title: "寄存器地址",
          key: "address",
          tree: true,
          render: (h, params) => {
            const address = params.row.address;
            return h("span", address || '-');
          },
        },
        {
          title: "字节序",
          key: "byteOrder",
          tree: true,
          render: (h, params) => {
            const byteOrder = params.row.byteOrder;
            return h("span", byteOrder ? byteOrderList.find((item) => item.value === byteOrder).label : '-');
          },
        },
        {
          title: "数据类型",
          key: "dataType",
          tree: true,
          render: (h, params) => {
            const item = params.row;
            let pointType = item.dataType;
            return h("span", this.dataTypes[pointType]);
          },
        },
        // {
        //   title: "读功能码",
        //   key: "readFunctionCode",
        //   tree: true,
        //   render: (h, params) => {
        //     const item = params.row;
        //     let readFunctionCode = item.readFunctionCode;
        //     return h("span", readFunctionCode || "-");
        //   },
        // },
        // {
        //   title: "写功能码",
        //   key: "writeFunctionCode",
        //   tree: true,
        //   render: (h, params) => {
        //     const item = params.row;
        //     let writeFunctionCode = item.writeFunctionCode;

        //     return h("span", writeFunctionCode || "-");
        //   },
        // },
        // {
        //   title: "交换字节顺序",
        //   key: "byteSwap",
        //   with: "250",
        //   render: (h, params) => {
        //     const item = params.row;
        //     let byteSwap = item.byteSwap;

        //        let text="-"
        //     if(byteSwap==true){
        //      text="是"
        //     }else if(byteSwap===false){
        //       text="否"
        //     }
        //     return h("span", text || "-");
        //   },
        // },
        // {
        //   title: "交换寄存器顺序",
        //   key: "registerSwap",
        //   render: (h, params) => {
        //     const item = params.row;
        //     let registerSwap = item.registerSwap;
        //     let text="-"
        //     if(registerSwap==true){
        //      text="是"
        //     }else if(registerSwap===false){
        //       text="否"
        //     }
           
           
        //     return h("span", text || "-");
        //   },
        // },
        {
          title: "小数位数",
          key: "dataLen",
          tree: true,
          render: (h, params) => {
            const item = params.row;
            let writeFunctionCode = item.dataLen;
            return h("span", writeFunctionCode !== null && writeFunctionCode !== undefined ? writeFunctionCode : "-");
          },
        },
        {
          title: "缩放因子",
          key: "scaling",
          tree: true,
          render: (h, params) => {
            const item = params.row;
            let writeFunctionCode = item.scaling;
            return h("span", writeFunctionCode || "-");
          },
        },
        {
          title: "数据转换参数b",
          key: "convertB",
          tree: true,
          render: (h, params) => {
            const item = params.row;
            let writeFunctionCode = item.convertB;
            return h("span", writeFunctionCode !== null && writeFunctionCode !== undefined ? writeFunctionCode : "-");
          },
        },
        {
          title: "计算值",
          key: "source",
          tree: true,
          render: (h, params) => {
            const item = params.row;
            let text = item.source == 0 ? "否" : "是";
            return h("span", text);
          },
        },

        {
          title: "操作",
          key: "address",
          align: "left",
          // fixed: 'right',

          className: "action",
          render: (h, params) => {
            const item = params.row;
            let btns = [
              h(
                "span",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    color: "#0c479d", //"#e9aa69",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.editDetailType(item, "edit");
                    },
                  },
                },
                "编辑"
              ),
            ];
            return btns;
          },
        },
      ];
    },
    closeDrawer() {
      this.$emit("input", false);
    },
  },
};
</script>
  
 
   
  <style lang='less' scoped>
::v-deep .ivu-modal-body .ivu-table-wrapper {
  min-height: 100px;
  overflow-y: hidden;
}
.common-page {
  margin-bottom: 0px;
}
</style>
<style lang="less">
.producEdit .ivu-table-body {
  overflow-x: hidden !important;
}
.comment {
  white-space: pre-wrap;
}

.producEdit .equipmentTable {
  max-height: 328px !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.producEdit .ivu-modal-wrap .ivu-modal {
}

.producEdit .ivu-table-default:after {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0) !important;
  z-index: 4;
}
.ivu-table:before {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0) !important;
  z-index: 4;
}
.product-title {
  font-size: 16px;
  font-weight: 400;
  color: #111111;
}
.resetIcon {
  position: relative;
  left: -24px;
  top: -2px;
  // img{
  //       width: 20px;
  // }
  // &:hover {
  //   filter: brightness(1.1); /* 改变亮度，使图像高亮 */

  // }
}
.resetIcon-border {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  .resetIcon-img {
    width: 20px;
    height: 20px;
    background-image: url("../../../assets/images/ckmrdb.svg");
    background-size: 100% 100%;
    // &:active {
    //   background-image: url("../../../assets/images/ckmrdbClick.svg");
    // }
  }
  &:hover {
    background: #e7e8e8;
  }
  &:active {
    div {
       background-image: url("../../../assets/images/ckmrdbClick.svg");
     
    }
    background-color: rgba(0, 112, 204,.2);
  }
}
</style>